import {
  Addresses,
  BrandData,
  CartItems,
  CustomersData,
  DiscountList,
  IdealFor,
  ProductColors,
  ProductTypes,
  ProductData,
  RecentOrders,
  OrderData,
  CinemaDetails,
  StateList,
} from '../../../../types/models/ecommerce/EcommerceApp';

export const brandData: BrandData[] = [
  {
    id: 1,
    name: 'Sushi',
  },
  {
    id: 2,
    name: 'Sashimi',
  },
  {
    id: 3,
    name: 'Appertizer',
  },
  {
    id: 4,
    name: 'Donburi',
  },
  {
    id: 5,
    name: 'Noodles',
  },
  {
    id: 6,
    name: 'Drinks',
  },
];

export const productTypes: ProductTypes = {
  1: 'Sushi',
  2: 'Sashimi',
  3: 'Appetizer',
  4: 'Donburi',
  5: 'Noodle',
  6: 'Drinks',
};

export const productColors: ProductColors = {
  BLUE: '#0A8FDC',
  GREY: '#8781BD',
  PARROT: '#A3D39C',
  RED: '#CD5C5C',
  PINK: '#F69679',
  PURPLE: '#912ADC',
};

export const idealFor: IdealFor[] = [
  {
    id: 1,
    name: 'Couple',
  },
  {
    id: 2,
    name: 'Men',
  },
  {
    id: 3,
    name: 'Women',
  },
  {
    id: 4,
    name: 'ALL',
  },
];

export const addresses: Addresses[] = [
  {
    id: 1,
    name: 'Crema User',
    mobile: '+1 508-966-0591',
    addressLine: '777 Brockton Avenue',
    city: 'Abington MA',
    pin: '2351',
  },
  {
    id: 2,
    name: 'Crema User',
    mobile: '+1 508-966-0592',
    addressLine: '250 Hartford Avenue',
    city: 'Bellingham MA',
    pin: '2322',
  },
  {
    id: 3,
    name: 'Crema User',
    mobile: '+1 508-966-0593',
    addressLine: '700 Oak Street',
    city: 'Brockton MA',
    pin: '2301',
  },
];

export const discountList: DiscountList[] = [
  {
    id: 1,
    name: '60% or more',
  },
  {
    id: 2,
    name: '50% or more',
  },
  {
    id: 3,
    name: '40% or more',
  },
  {
    id: 4,
    name: '30% or more',
  },
  {
    id: 5,
    name: '20% or more',
  },
  {
    id: 6,
    name: '10% or more',
  },
];

export const cartItems: CartItems[] = [
  /*
  {
    id: 1,
    title: "Edamame",
    mrp: '120',
    discount: '25',
    brand: 'Appetizer',
    type: productTypes[3],
    image: './assets/images/ecommerce/Edamame.png',
    count: 1,
  },
  {
    id: 2,
    title: "Inari",
    mrp: '125',
    discount: '20',
    brand: 'Sushi',
    type: productTypes[1],
    image: './assets/images/ecommerce/Inari.png',
    count: 1,
  },
  {
    id: 3,
    title: 'Salmon Sushi',
    mrp: '100',
    discount: '30',
    brand: 'Sushi',
    type: productTypes[1],
    image: './assets/images/ecommerce/SalmonSushi.png',
    count: 1,
  },
*/
];

// export const drinks: ProductData[] = [
//   {
//     id: 8,
//     title: "Green Tea",
//     description:
//       'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
//     mrp: '1',
//     discount: '0',
//     ideaFor: 2,
//     brand: 6,
//     rating: 2,
//     type: "Drinks",
//     color: "",
//     reviews: 4323,
//     image: [
//       {
//         id: 344,
//         src: './assets/images/ecommerce/GreenTea.png',
//       },
//       {
//         id: 4342,
//         src: './assets/images/ecommerce/GreenTea.png',
//       },
//       {
//         id: 7654,
//         src: './assets/images/ecommerce/GreenTea.png',
//       },
//       {
//         id: 3232,
//         src: './assets/images/ecommerce/GreenTea.png',
//       },
//     ],
//   },
//   {
//     id: 9,
//     title: "Iced Lemon Tea",
//     description:
//       'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
//     mrp: '7',
//     discount: '0',
//     brand: 6,
//     ideaFor: 1,
//     rating: 5,
//     type: productTypes[6],
//     color: productColors.GREY,
//     reviews: 2000,
//     image: [
//       {
//         id: 0,
//         src: './assets/images/ecommerce/IcedLemonTea.png',
//       },
//       {
//         id: 0,
//         src: './assets/images/ecommerce/IcedLemonTea.png',
//       },
//       {
//         id: 42334324,
//         src: './assets/images/ecommerce/IcedLemonTea.png',
//       },
//       {
//         id: 333245,
//         src: './assets/images/ecommerce/IcedLemonTea.png',
//       },
//     ],
//   },
// ];

const ecommerceData: ProductData[] = [
  // {
  //   id: 1,
  //   title: "Edamame",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '5',
  //   discount: '0',
  //   rating: 5,
  //   ideaFor: 1,
  //   brand: 3,
  //   type: productTypes[3],
  //   color: productColors.PARROT,
  //   reviews: 2000,
  //   image: [
  //     {
  //       id: 3332,
  //       src: './assets/images/ecommerce/Edamame.png',
  //     },
  //     {
  //       id: 43554,
  //       src: './assets/images/ecommerce/Edamame.png',
  //     },
  //     {
  //       id: 434324,
  //       src: './assets/images/ecommerce/Edamame.png',
  //     },
  //     {
  //       id: 33245,
  //       src: './assets/images/ecommerce/Edamame.png',
  //     },
  //   ],
  // },
  // {
  //   id: 2,
  //   title: "Inari",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '3',
  //   brand: 1,
  //   ideaFor: 3,
  //   discount: '0',
  //   rating: 4,
  //   type: productTypes[1],
  //   color: productColors.PINK,
  //   reviews: 4356,
  //   image: [
  //     {
  //       id: 3,
  //       src: './assets/images/ecommerce/Inari.png',
  //     },
  //     {
  //       id: 43,
  //       src: './assets/images/ecommerce/Inari.png',
  //     },
  //     {
  //       id: 23,
  //       src: './assets/images/ecommerce/Inari.png',
  //     },
  //     {
  //       id: 54,
  //       src: './assets/images/ecommerce/Inari.png',
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   title: 'Salmon Sushi',
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '5',
  //   ideaFor: 4,
  //   brand: 1,
  //   discount: '0',
  //   rating: 4,
  //   type: productTypes[1],
  //   color: productColors.PINK,
  //   reviews: 235,
  //   image: [
  //     {
  //       id: 4343,
  //       src: './assets/images/ecommerce/SalmonSushi.png',
  //     },
  //     {
  //       id: 323243,
  //       src: './assets/images/ecommerce/SalmonSushi.png',
  //     },
  //     {
  //       id: 325432,
  //       src: './assets/images/ecommerce/SalmonSushi.png',
  //     },
  //     {
  //       id: 653323,
  //       src: './assets/images/ecommerce/SalmonSushi.png',
  //     },
  //   ],
  // },
  // {
  //   id: 4,
  //   title: "Salmon Mentai",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '5',
  //   discount: '0',
  //   rating: 4,
  //   ideaFor: 2,
  //   brand: 1,
  //   type: productTypes[1],
  //   color: productColors.PINK,
  //   reviews: 4323,
  //   image: [
  //     {
  //       id: 4343443,
  //       src: './assets/images/ecommerce/SalmonMentai.png',
  //     },
  //     {
  //       id: 324324,
  //       src: './assets/images/ecommerce/SalmonMentai.png',
  //     },
  //     {
  //       id: 655434,
  //       src: './assets/images/ecommerce/SalmonMentai.png',
  //     },
  //     {
  //       id: 243443,
  //       src: './assets/images/ecommerce/SalmonMentai.png',
  //     },
  //   ],
  // },
  // {
  //   id: 5,
  //   title: "Oyaka Don",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '12',
  //   ideaFor: 1,
  //   brand: 4,
  //   discount: '0',
  //   rating: 3,
  //   type: productTypes[4],
  //   color: productColors.BLUE,
  //   reviews: 2000,
  //   image: [
  //     {
  //       id: 43434345,
  //       src: './assets/images/ecommerce/OyakaDon.png',
  //     },
  //     {
  //       id: 44343,
  //       src: './assets/images/ecommerce/OyakaDon.png',
  //     },
  //     {
  //       id: 5654443,
  //       src: './assets/images/ecommerce/OyakaDon.png',
  //     },
  //     {
  //       id: 433343,
  //       src: './assets/images/ecommerce/OyakaDon.png',
  //     },
  //   ],
  // },
  // {
  //   id: 6,
  //   title: "Chicken Katsudon",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '12',
  //   discount: '0',
  //   ideaFor: 3,
  //   brand: 4,
  //   rating: 3,
  //   type: productTypes[4],
  //   color: productColors.BLUE,
  //   reviews: 4356,
  //   image: [
  //     {
  //       id: 4354,
  //       src: './assets/images/ecommerce/ChickenKatsudon.png',
  //     },
  //     {
  //       id: 2343,
  //       src: './assets/images/ecommerce/ChickenKatsudon.png',
  //     },
  //     {
  //       id: 233,
  //       src: './assets/images/ecommerce/ChickenKatsudon.png',
  //     },
  //     {
  //       id: 544,
  //       src: './assets/images/ecommerce/ChickenKatsudon.png',
  //     },
  //   ],
  // },
  // {
  //   id: 7,
  //   title: 'Chuka Wakame',
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '5',
  //   ideaFor: 4,
  //   brand: 3,
  //   discount: '0',
  //   rating: 4,
  //   type: productTypes[3],
  //   color: productColors.PARROT,
  //   reviews: 235,
  //   image: [
  //     {
  //       id: 4344343,
  //       src: './assets/images/ecommerce/ChukaWakame.png',
  //     },
  //     {
  //       id: 32443243,
  //       src: './assets/images/ecommerce/ChukaWakame.png',
  //     },
  //     {
  //       id: 32544432,
  //       src: './assets/images/ecommerce/ChukaWakame.png',
  //     },
  //     {
  //       id: 654333323,
  //       src: './assets/images/ecommerce/ChukaWakame.png',
  //     },
  //   ],
  // },
  // {
  //   id: 10,
  //   title: "Niku",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '9',
  //   discount: '0',
  //   ideaFor: 2,
  //   brand: 5,
  //   rating: 4,
  //   type: productTypes[5],
  //   color: productColors.PURPLE,
  //   reviews: 4356,
  //   image: [
  //     {
  //       id: 32222,
  //       src: './assets/images/ecommerce/Niku.png',
  //     },
  //     {
  //       id: 3333,
  //       src: './assets/images/ecommerce/Niku.png',
  //     },
  //     {
  //       id: 4444,
  //       src: './assets/images/ecommerce/Niku.png',
  //     },
  //     {
  //       id: 5555,
  //       src: './assets/images/ecommerce/Niku.png',
  //     },
  //   ],
  // },
  // {
  //   id: 11,
  //   title: 'Cha Soba',
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '9',
  //   discount: '0',
  //   rating: 3,
  //   ideaFor: 3,
  //   brand: 5,
  //   type: productTypes[5],
  //   color: productColors.PURPLE,
  //   reviews: 235,
  //   image: [
  //     {
  //       id: 43333332343,
  //       src: './assets/images/ecommerce/ChaSoba.png',
  //     },
  //     {
  //       id: 323232,
  //       src: './assets/images/ecommerce/ChaSoba.png',
  //     },
  //     {
  //       id: 54554,
  //       src: './assets/images/ecommerce/ChaSoba.png',
  //     },
  //     {
  //       id: 4343232,
  //       src: './assets/images/ecommerce/ChaSoba.png',
  //     },
  //   ],
  // },
  // {
  //   id: 8,
  //   title: "Salmon Shashimi",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '15',
  //   discount: '0',
  //   rating: 4,
  //   ideaFor: 2,
  //   type: productTypes[2],
  //   color: productColors.RED,
  //   reviews: 4323,
  //   brand: 2,
  //   image: [
  //     {
  //       id: 43343443,
  //       src: './assets/images/ecommerce/SalmonShashimi.png',
  //     },
  //     {
  //       id: 333224324,
  //       src: './assets/images/ecommerce/SalmonShashimi.png',
  //     },
  //     {
  //       id: 5545454,
  //       src: './assets/images/ecommerce/SalmonShashimi.png',
  //     },
  //     {
  //       id: 42332323,
  //       src: './assets/images/ecommerce/SalmonShashimi.png',
  //     },
  //   ],
  // },
  // {
  //   id: 9,
  //   title: "Toro Shashimi",
  //   description:
  //     'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters',
  //   mrp: '15',
  //   discount: '0',
  //   rating: 4,
  //   ideaFor: 2,
  //   type: productTypes[2],
  //   color: productColors.RED,
  //   reviews: 4323,
  //   brand: 2,
  //   image: [
  //     {
  //       id: 43343443,
  //       src: './assets/images/ecommerce/ToroShashimi.png',
  //     },
  //     {
  //       id: 333224324,
  //       src: './assets/images/ecommerce/ToroShashimi.png',
  //     },
  //     {
  //       id: 5545454,
  //       src: './assets/images/ecommerce/ToroShashimi.png',
  //     },
  //     {
  //       id: 42332323,
  //       src: './assets/images/ecommerce/ToroShashimi.png',
  //     },
  //   ],
  // },
];
 export const recentOrders: RecentOrders[] = [
  // {
  //   Transaction:
  //   {
  //     TrxnOutletId:'268',
  //     TrxnNo:'6374757',
  //     TrxnDate:'2020-03-12 13:30:01',
  //     CollectionDate:'2021-09-12',
  //   },
  //   Concessions:
  //   [
  //     {
  //       ProductCode:'2006001',
  //       ProductName:'Combo 1',
  //       ProductQty:1,
  //       ProductPrice:15,
  //     },
  //     {
  //       ProductCode:'2006002',
  //       ProductName:'Combo 2',
  //       ProductQty:2,
  //       ProductPrice:19,
  //     },
  //   ],
  //   Summary: {
  //     TotalNetPaymentDesc: 'Total',
  //     TotalNetPayment: 34,
  //   },
  //   QRCode:'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',
  // },
 ];

export const customersData: CustomersData[] = [
  {
    id: 1,
    name: 'Josh Rash',
    email: 'josh@exmaple.com',
    lastItem: 'Apple Watch',
    lastOrder: '26 Aug',
    rating: '4.6',
    balance: '$125',
    address: '675 Grove Street Bethpage, NY 11714',
    joinDate: '23 Jan, 2015',
  },
  {
    id: 2,
    name: 'Josh Rash',
    email: 'josh@exmaple.com',
    lastItem: 'Apple Watch',
    lastOrder: '26 Aug',
    rating: '4.6',
    balance: '$125',
    address: '675 Grove Street Bethpage, NY 11714',
    joinDate: '23 Jan, 2015',
  },
  {
    id: 3,
    name: 'Josh Rash',
    email: 'josh@exmaple.com',
    lastItem: 'Apple Watch',
    lastOrder: '26 Aug',
    rating: '4.6',
    balance: '$125',
    address: '675 Grove Street Bethpage, NY 11714',
    joinDate: '23 Jan, 2015',
  },
  {
    id: 4,
    name: 'Josh Rash',
    email: 'josh@exmaple.com',
    lastItem: 'Apple Watch',
    lastOrder: '26 Aug',
    rating: '4.6',
    balance: '$125',
    address: '675 Grove Street Bethpage, NY 11714',
    joinDate: '23 Jan, 2015',
  },
  {
    id: 5,
    name: 'Josh Rash',
    email: 'josh@exmaple.com',
    lastItem: 'Apple Watch',
    lastOrder: '26 Aug',
    rating: '4.6',
    balance: '$125',
    address: '675 Grove Street Bethpage, NY 11714',
    joinDate: '23 Jan, 2015',
  },
];

export const orderData: OrderData[] = [
  {
    id: 1,
    branch: 'OneUtama',
    table: 1,
    date: '20210601',
    time: '1000',
    orderid: 'OU-1',
  },
  {
    id: 2,
    branch: 'OneUtama',
    table: 2,
    date: '20210801',
    time: '1000',
    orderid: 'OU-2',
  },
  {
    id: 3,
    branch: 'Damansara3',
    table: 1,
    date: '20210601',
    time: '1000',
    orderid: 'D3-1',
  },
  {
    id: 4,
    branch: 'Damansara3',
    table: 2,
    date: '20210601',
    time: '1000',
    orderid: 'D3-2',
  },
  {
    id: 5,
    branch: 'ParadigmMall',
    table: 1,
    date: '20210601',
    time: '1000',
    orderid: 'PD-1',
  },
];

export const cinemalist : CinemaDetails[] = [
	{ 
    id:'118', 
    name:'GSC Gurney Plaza',
  }, 	
	{ 
    id:'120', 
    name:'GSC Queensbay Mall',
  }, 
	{ 
    id:'123', 
    name:'GSC Sunway Carnival',
  }, 
	{ 
    id:'132', 
    name:'GSC Amanjaya Mall',
  }, 
	{ 
    id:'133', 
    name:'GSC Aman Central',
  }, 
	{ 
    id:'135', 
    name:'GSC Kulim Central',
  }, 
	{ 
    id:'136', 
    name:'GSC Central Square',
  }, 
	{ 
    id:'151', 
    name:'GSC Ipoh Parade Mall',
  }, 
	{ 
    id:'210', 
    name:'GSC Mid Valley',
  }, 
	{ id:'211', name:'GSC Cheras Leisure Mall',}, 
	{ id:'212', name:'GSC MyTown',}, 
	{ id:'213', name:'GSC EkoCheras Mall',}, 
	{ id:'215', name:'Aurum The Gardens Mall',}, 
	{ id:'221', name:'GSC Berjaya Times Square',}, 
	{ id:'223', name:'GSC NU Sentral',}, 
	{ id:'231', name:'GSC Quill City Mall',}, 
	{ id:'233', name:'GSC Setapak Central',}, 
	{ id:'235', name:'GSC Kepong Village Mall',}, 
	{ id:'250', name:'GSC Summit USJ',}, 
	{ id:'251', name:'GSC Subang Parade',}, 
	{ id:'253', name:'GSC IOI Mall (Puchong)',},
	{ id:'255', name:'GSC Alamanda',},
	{ id:'256', name:'GSC Setia City Mall',},
	{ id:'257', name:'GSC IOI City Mall (Putrajaya)',},
	{ id:'258', name:'GSC Klang Parade',},
	{ id:'260', name:'GSC 1 Utama',},
	{ id:'265', name:'GSC 3 Damansara (formerly Tropicana City Mall)',},
	{ id:'266', name:'GSC The Starling Mall',},
	{ id:'267', name:'GSC CITTA Mall',},
	{ id:'268', name:'GSC Paradigm Mall (Petaling Jaya)',},
	{ id:'269', name:'GSC Tropicana Gardens Mall',},
	{ id:'281', name:'GSC Melawati Mall',},
	{ id:'310', name:'GSC Terminal 1',},
	{ id:'311', name:'GSC Palm Mall',},
	{ id:'331', name:'GSC Dataran Pahlawan',},
	{ id:'333', name:'GSC Aeon Bandaraya Melaka',},
	{ id:'355', name:'GSC Paradigm Mall (Johor Bahru)',},
	{ id:'356', name:'GSC Southkey Mall',},
	{ id:'358', name:'GSC Kluang Mall',},
	{ id:'359', name:'GSC KSL City Mall',},
	{ id:'361', name:'GSC Square One Shopping Mall',},
	{ id:'362', name:'GSC Heritage Mall',},
	{ id:'410', name:'GSC Berjaya Megamall (Kuantan)',},
	{ id:'420', name:'GSC East Coast Mall',},
	{ id:'430', name:'GSC Mentakab Star Mall',},
	{ id:'431', name:'GSC Kuantan City Mall',},
	{ id:'520', name:'GSC 1Borneo',},
	{ id:'530', name:'GSC Suria Sabah Mall',},
	{ id:'531', name:'GSC IMAGO Shopping Mall',},
	{ id:'550', name:'GSC Bintang Megamall',},
	{ id:'551', name:'GSC CityONE Megamall (Kuching)',},
	{ id:'552', name:'GSC The Spring',},
];


export const statelist : StateList[] = [
  {
    id:'JHR',
    name:'Johor',
  },
  {
    id:'KDH',
    name:'Kedah',
  },
  {
    id:'KTN',
    name:'Kelantan',
  },
  {
    id:'KUL',
    name:'Kuala Lumpur',
  },
  {
    id:'LBN',
    name:'Labuan',
  },
  {
    id:'MLK',
    name:'Malacca',
  },
  {
    id:'NSN',
    name:'Negeri Sembilan',
  },
  {
    id:'OTHERS',
    name:'Others',
  },
  {
    id:'PHG',
    name:'Pahang',
  },
  {
    id:'PJY',
    name:'Putrajaya',
  },
  {
    id:'PLS',
    name:'Perlis',
  },
  {
    id:'PNG',
    name:'Penang',
  },
  {
    id:'PRK',
    name:'Perak',
  },
  {
    id:'SBH',
    name:'Sabah',
  },
  {
    id:'SGR',
    name:'Selangor',
  },
  {
    id:'SWK',
    name:'Sarawak',
  },
  {
    id:'TRG',
    name:'Terengganu',
  },
]
export default ecommerceData;
